<clr-tooltip role="tooltip" aria-haspopup="true">
  <select id="pagination" name="pagination" class="pageSize" [ngModel]="pageSizeValue" (ngModelChange)="changed.emit($event)">
    <option *ngFor="let page of pages" [ngValue]="page.pagination">{{page.pagination}}</option>
  </select>
  <clr-tooltip-content class="tooltip-content">{{ content }}</clr-tooltip-content>
</clr-tooltip>
